import { RootState } from 'types/state';

export const getUserAuthenticated = (state: RootState) => state.authentication.authenticated;
export const getLastLogin = (state: RootState) => state.authentication.lastLogin;
export const getLastSession = (state: RootState) => state.authentication.lastSessionRenewed;
export const getToken = (state: RootState) => state.authentication.token;
